import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { PlanoAcaoSituacaoService } from "../services/plano-acao-situacao.service";

@Injectable({
  providedIn: 'root'
})
export class PlanoAcaoSituacaoListResolver implements Resolve<boolean> {

  constructor(private service: PlanoAcaoSituacaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdListEdit(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PlanoAcaoSituacaoResolver implements Resolve<boolean> {

  constructor(private service: PlanoAcaoSituacaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}